import { useDispatch, useSelector } from "react-redux";
import { FileUploader } from "../../components";
import { useFormContext } from "react-hook-form";
import { RootState } from "../../store/root-reducer";
import {
  removeClaimImage,
  uploadClaimImage,
} from "../../store/mattress-claim/actions";

function UploadDocuments() {
  const { control } = useFormContext();
  const claim = useSelector((state: RootState) => state.claim);
  const dispatch = useDispatch();

  return (
    <div className="grid gap-y-6">
      <FileUploader
        required
        control={control}
        name="documents.protector_damage_images"
        label="Three (3) photos of the stained or damaged product"
        isMultiple
        uploadedFiles={claim.documents.protector_damage_images}
        minFile={3}
        onlyImage
        onFileSelect={(files) =>
          dispatch(
            uploadClaimImage({
              files,
              storeKeyName: "documents.protector_damage_images",
              isMultiple: true,
            })
          )
        }
        onDeleteImage={(fileName) =>
          dispatch(
            removeClaimImage({
              fileName,
              storeKeyName: "documents.protector_damage_images",
            })
          )
        }
      />
      {claim.damageInfo.mattress_stained_damaged && (
        <FileUploader
          required
          control={control}
          name="documents.mattress_damage_images"
          label="Three (3) photos of the stained or damaged mattress"
          isMultiple
          onlyImage
          uploadedFiles={claim.documents.mattress_damage_images}
          minFile={3}
          onFileSelect={(files) =>
            dispatch(
              uploadClaimImage({
                files,
                storeKeyName: "documents.mattress_damage_images",
                isMultiple: true,
              })
            )
          }
          onDeleteImage={(fileName) =>
            dispatch(
              removeClaimImage({
                fileName,
                storeKeyName: "documents.mattress_damage_images",
              })
            )
          }
        />
      )}
      <FileUploader
        control={control}
        name="documents.protectall_tag_image"
        label="ProtectALL Product Tag Photo"
        required
        onlyImage
        uploadedFiles={
          claim.documents.protectall_tag_image
            ? [claim.documents.protectall_tag_image]
            : []
        }
        onFileSelect={(files) =>
          dispatch(
            uploadClaimImage({
              files,
              storeKeyName: "documents.protectall_tag_image",
            })
          )
        }
      />
    </div>
  );
}

export default UploadDocuments;
